<mat-dialog-content>
	<div *ngIf="isRapipago" class="container mt-2">
		<div class="row justify-content-between">
			<div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 align-self-center">
				<div class="row justify-content-center">
					<img alt="cargando imagen" src="assets/images/rapipago.logo.png" width="150px" />
				</div>
				<div class="row m-auto"></div>
			</div>
		</div>
	</div>
</mat-dialog-content>

<div class="info-data mb-5 text-center" *ngIf="isRapipago && !isRapipagoOK">
	<h5 class="info-title">{{ 'pages.cashin_cashout.disabledRapipago' | translate }}</h5>
</div>
<div class="container mt-2" *ngIf="isRapipago && isRapipagoOK">
    <div class="row justify-content-start m-3" #imgBar>
        <mat-label>
            <span color="primary">1. </span>Acercate a una
            sucursal
        </mat-label>
    </div>
    <div class="container mt-2" *ngIf="isRapipago && isRapipagoOK" id="code">
        <div class="row justify-content-start m-3" #imgBar>
            <mat-label>
                <span color="primary">2. </span>Presenta tu DNI y este código
            </mat-label>
        </div>

        <div size="12" class="row justify-content-center m-3">
            <span class="font-weight-bold">{{ codeBar }}</span>
        </div>
    </div>
</div>

<mat-dialog-content *ngIf="!isRapipago">
	<div class="container mt-2">
		<div class="row justify-content-between m-3">
			<div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 align-self-center">
				<div class="row justify-content-center">
					<mat-label>
						<span color="primary">Retiro de dinero</span>
					</mat-label>
					<mat-form-field class="mb-2 ml-5 mr-5 wrapperLeft">
						<input
							matInput
							#currencyInput
							[ngModel]="cashOutInputCurrency"
							(ngModelChange)="monto = currencyInputChanged($event)"
							formControlName="comercioMonto"
							autocomplete="false"
							appCurrencyValidator
							type="tel"
							class="currency-input"
						/>
						<mat-error *ngIf="formControls.comercioMonto.invalid">{{ getErrorMessage(6) }}</mat-error>
						<mat-error *ngIf="!this.montoDown">{{ getError }}</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 align-self-center" *ngIf="!isRapipago">
				<div class="row justify-content-center">
					<mat-label>
						<span color="primary">Destinatario</span>
					</mat-label>
					<mat-form-field class="mb-2 ml-5 mr-5">
						<input
							id="bancoForm"
							required
							matInput
							formControlName="bancoForm"
							maxlength="22"
							minlength="6"
							placeholder="CBU/CVU/ALIAS"
						/>
						<mat-error>Ingresá un CBU, CVU o ALIAS válido</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 align-self-center" *ngIf="!isRapipago">
				<div class="row justify-content-center">
					<mat-form-field class="mb-2 ml-5 mr-5 wrapperLeft">
						<input matInput value="{{ cashOut.cuit }}" [readonly]="true" placeholder="CUIT" />
					</mat-form-field>
					<mat-form-field class="mb-2 ml-5 mr-5 wrapperLeft">
						<input matInput value="{{ cashOut.titular }}" [readonly]="true" placeholder="Titular" />
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<div class="row m-none">
		<button mat-raised-button mat-dialog-close class="mr-2 w-button button-actions">
			{{ isRapipago ? 'Cerrar' : 'Cancelar' }}
		</button>
		<button
			*ngIf="!isRapipago"
			mat-raised-button
			(click)="consultaCVU()"
			tabindex="0"
			color="primary"
			class="w-button mr-2 button-actions font-clear"
			[class.spinner]="loading"
			[disabled]="loading"
		>
			Continuar
		</button>
		<button
			*ngIf="!isRapipago"
			mat-raised-button
			(click)="volverConsulta()"
			tabindex="0"
			class="w-button mr-2 button-actions"
		>
			Volver
		</button>
		<button
			*ngIf="!isRapipago"
			mat-raised-button
			type="submit"
			tabindex="0"
			color="primary"
			class="w-button mr-2 button-actions font-clear"
			[class.spinner]="loading"
			[disabled]="loading"
		>
			Transferir
		</button>
		<button
			*ngIf="isRapipago && isRapipagoOK"
			matSuffix
			mat-raised-button
			(click)="descargarImagen()"
			tabindex="1"
			color="primary"
			class="w-button mr-2 font-clear"
		>
			Descargar&nbsp;<mat-icon>cloud_download</mat-icon>
		</button>
		<button
			*ngIf="isRapipago && isRapipagoOK"
			matSuffix
			mat-raised-button
			(click)="imprimir()"
			tabindex="2"
			color="primary"
			class="w-button mr-2 font-clear"
		>
			Imprimir&nbsp;<mat-icon>print</mat-icon>
		</button>
	</div>
</mat-dialog-actions>
